import React from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Edit, Trash2 } from "lucide-react";

export const ToDoMemberTable = ({
  paginatedMembers,
  filteredMembers,
  selectedMembers,
  toggleSelectMember,
  toggleSelectAll,
  onEdit,
  onDelete,
}) => {
  const selectableCount = filteredMembers.filter((m) => m.member_type === "ndp").length;
  const allSelected = selectableCount > 0 && selectedMembers.length === selectableCount;

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-[#0f0f10] border-red-900/30 hover:bg-[#0f0f10]">
            <TableHead className="w-12">
              <Checkbox
                checked={allSelected}
                onCheckedChange={toggleSelectAll}
                className="border-red-600 data-[state=checked]:bg-red-600"
                data-testid="select-all-checkbox"
              />
            </TableHead>
            <TableHead className="text-red-400 font-semibold">Username</TableHead>
            <TableHead className="text-red-400 font-semibold">Marketing</TableHead>
            <TableHead className="text-red-400 font-semibold">Website</TableHead>
            <TableHead className="text-red-400 font-semibold">Kode DB</TableHead>
            <TableHead className="text-red-400 font-semibold">No. HP</TableHead>
            <TableHead className="text-red-400 font-semibold">Status</TableHead>
            <TableHead className="text-red-400 font-semibold">Nominal Depo</TableHead>
            <TableHead className="text-red-400 font-semibold">Follow Up</TableHead>
            <TableHead className="text-red-400 font-semibold">Tanggal</TableHead>
            <TableHead className="text-red-400 font-semibold">Catatan</TableHead>
            <TableHead className="text-red-400 font-semibold text-center">Aksi</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {paginatedMembers.map((member) => (
            <TableRow
              key={member.id}
              className="border-red-900/20 hover:bg-[#0f0f10]/50"
              data-testid={"member-row-" + member.id}
            >
              <TableCell>
                <Checkbox
                  checked={selectedMembers.includes(member.id)}
                  onCheckedChange={() => toggleSelectMember(member.id)}
                  disabled={member.member_type === "regis"}
                  className="border-red-600 data-[state=checked]:bg-red-600 disabled:opacity-30"
                  data-testid={"select-member-" + member.id}
                />
              </TableCell>
              <TableCell className="font-medium text-white">{member.username}</TableCell>
              <TableCell className="text-gray-300">{member.marketing_name}</TableCell>
              <TableCell className="text-gray-300">{member.website}</TableCell>
              <TableCell className="text-gray-300">{member.kode_db}</TableCell>
              <TableCell className="text-gray-300">{member.phone}</TableCell>
              <TableCell>
                {member.member_type === "ndp" ? (
                  <span className="px-2 py-1 rounded text-xs font-semibold bg-green-900/30 text-green-400 border border-green-700/50">
                    NDP
                  </span>
                ) : (
                  <span className="px-2 py-1 rounded text-xs font-semibold bg-yellow-900/30 text-yellow-400 border border-yellow-700/50">
                    REGIS
                  </span>
                )}
              </TableCell>
              <TableCell className="text-green-400 font-semibold">
                {member.member_type === "ndp" && member.nominal_depo
                  ? "Rp " + member.nominal_depo.toLocaleString("id-ID")
                  : "-"}
              </TableCell>
              <TableCell className="text-blue-400 font-medium">{member.closed_by || "-"}</TableCell>
              <TableCell className="text-gray-300 text-xs">
                {new Date(member.created_at).toLocaleDateString("id-ID")}
              </TableCell>
              <TableCell className="max-w-xs">
                {member.notes ? (
                  <div className="text-xs text-gray-300 truncate" title={member.notes}>
                    {member.notes}
                  </div>
                ) : (
                  <span className="text-gray-500 text-xs">-</span>
                )}
              </TableCell>
              <TableCell className="text-center">
                <div className="flex items-center justify-center gap-2">
                  <Button
                    onClick={() => onEdit(member)}
                    variant="ghost"
                    size="sm"
                    className="text-blue-400 hover:text-blue-300 hover:bg-blue-900/20"
                    data-testid={"edit-member-" + member.id}
                  >
                    <Edit size={16} />
                  </Button>
                  <Button
                    onClick={() => onDelete(member.id, member.username)}
                    variant="ghost"
                    size="sm"
                    className="text-red-400 hover:text-red-300 hover:bg-red-900/20"
                    data-testid={"delete-member-" + member.id}
                  >
                    <Trash2 size={16} />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ToDoMemberTable;
